import { useEffect, useState } from 'react';

export function useScrollSpy(
  sectionIds: Array<string>,
  options?: IntersectionObserverInit,
) {
  const [activeId, setActiveId] = useState<string | null>(null);

  useEffect(() => {
    const intersecting = new Set<string>();

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const id = entry.target.id;
        if (entry.isIntersecting) {
          intersecting.add(id);
        } else {
          intersecting.delete(id);
        }
      });

      const nextActive = sectionIds.find((id) => intersecting.has(id));

      if (nextActive) {
        setActiveId(nextActive);
      }
    }, options);

    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [sectionIds, options]);

  return activeId;
}
